import { render, staticRenderFns } from "./postTelegram.vue?vue&type=template&id=9aa912ac"
import script from "./postTelegram.vue?vue&type=script&lang=js"
export * from "./postTelegram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aa912ac')) {
      api.createRecord('9aa912ac', component.options)
    } else {
      api.reload('9aa912ac', component.options)
    }
    module.hot.accept("./postTelegram.vue?vue&type=template&id=9aa912ac", function () {
      api.rerender('9aa912ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postTelegram.vue"
export default component.exports